import {Middleware} from '@reduxjs/toolkit'

import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import authMiddleware from './authMiddleware'
import errorLoggerMiddleware from './errorLoggerMiddleware'
import loggerMiddleware from './loggerMiddleware'
import maintenanceHandlerMiddleware from './maintenanceHandlerMiddleware'
import orderInterruptedMiddleware from './orderInterruptedMiddleware'
import sentryMiddleware from './sentryMiddleware'
import uiEventLoggerMiddleware from './uiEventLoggerMiddleware'

const Middlewares: Middleware[] = [
    authMiddleware,
    maintenanceHandlerMiddleware,
    loggerMiddleware,
    orderInterruptedMiddleware,
    sentryMiddleware,
    uiEventLoggerMiddleware,
    browserEventEmitter,
    errorLoggerMiddleware,
]
export default Middlewares
